/* unplugin-vue-components disabled */import script from "./Department.vue?vue&type=script&setup=true&lang=ts"
export * from "./Department.vue?vue&type=script&setup=true&lang=ts"

import "./Department.vue?vue&type=style&index=0&id=5976456b&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5976456b"]])

export default __exports__